// Avatars use the four spectrum colors as a light tint behind dark initials.
const AVATARS = ['#3070e7', '#16bdeb', '#ff007f', '#ff9000'];

/** Initials and a stable tint for a name, so the same item or account always looks the same. */
export function avatarFor(label: string): { initials: string; bg: string } {
  const words = label.split(/\s+/).filter(Boolean);
  const initials = (words[0]?.[0] || '?') + (words[1]?.[0] || '');
  const hash = Array.from(label).reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);
  return { initials: initials.toUpperCase(), bg: `${AVATARS[hash % AVATARS.length]}26` };
}
